import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notification } from '../../../Store/api/professor/settings';
import storage from '../../../services/storage';
import ArrowRight from '../../../assets/images/Arrow-right-dark.svg';

export default function Notifications() {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [err, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const [isNotificationOn, setIsNotificationOn] = useState(user.receiveNotification);
  useEffect(() => {
    setIsNotificationOn(user.receiveNotification);
  }, [user]);
  return (
    <div className='box_border_settings'>
      <div className='settings_header'>
        <h2>notification settings</h2>
        <div className='settings_header'>
          <p
            className='mb-0 editt cursor'
            onClick={() => {
              setIsEditing((e) => !e);
            }}
          >
            {isEditing ? 'editing' : 'edit'}
          </p>
        </div>
      </div>
      <div className='setting_rows'>
        <p className='key' style={{ width: '60%' }}>
          Receive notifications by email
        </p>

        {isEditing ? (
          <Fragment>
            <p style={{ width: '10%' }}></p>
            <p
              style={{
                width: '30%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <label
                for='yes'
                onClick={() => {
                  setIsNotificationOn(true);
                }}
              >
                Yes
                <input type='radio' name='noti' id='yes' checked={isNotificationOn} value={'yes'} className='custome_radio cursor' />
                <span></span>
              </label>
              <label
                for='no'
                onClick={() => {
                  setIsNotificationOn(false);
                }}
              >
                No
                <input type='radio' name='noti' checked={!isNotificationOn} id='no' value={'yes'} className='custome_radio cursor' />
                <span></span>
              </label>
            </p>
          </Fragment>
        ) : (
          <Fragment>
            <p style={{ width: '30%' }}></p>
            <p
              className='value'
              style={{
                width: '10%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              {isNotificationOn ? 'Yes' : 'No'}
            </p>
          </Fragment>
        )}
      </div>
      {isEditing && (
        <div className='setting_rows' style={{ marginBottom: '0px' }}>
          <p className='key'></p>
          <p className='value'>
            <p className='main_part' style={{ color: 'red' }}>
              {err && `${err}`}
            </p>
            <p
              className='edit_buttton cursor'
              onClick={() => {
                setError(null);
                setIsLoading(true);
                dispatch(
                  notification({
                    body: { receiveNotification: isNotificationOn },
                    onSuccess: (res) => {
                      setIsLoading(false);
                      storage.store('user', res.data.data);
                    },
                    onError: (error) => {
                      setIsLoading(false);
                      if (error.response.data && error.response.data.message) {
                        setError(error.response.data.message);
                      } else {
                        setError('Something went wrong!');
                      }
                    },
                  })
                );
              }}
            >
              Save <img src={ArrowRight} alt='save' className='ms-1' />
            </p>
          </p>
        </div>
      )}
    </div>
  );
}
